module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_8003.c0ba6007.png";